import * as React from 'react';
import { inject, observer } from 'mobx-react';
import ErrorUtil from '../util/ErrorUtil';
import FieldContainer from './FieldContainer';
import FieldHelper from './FieldHelper';
import Select from './Select';
import Multiselect from './Multiselect';
import Textfield from './Textfield';
import Textarea from './Textarea';
import Hidden from './Hidden';
import Checkbox from './Checkbox';
import HtmlContent from './HtmlContent';
import Radio from './Radio';
import Date from './Datepicker';
import ChoiceAgreement from './ChoiceAgreement';
const fieldFromType = (type) => {
    switch (type) {
        case 'number':
        case 'phone':
        case 'email':
        case 'text':
            return Textfield;
        case 'textarea':
            return Textarea;
        case 'radio':
            return Radio;
        case 'checkbox':
            return Checkbox;
        case 'select':
            return Select;
        case 'multiselect':
            return Multiselect;
        case 'date':
            return Date;
        case 'html':
            return HtmlContent;
        case 'consent':
            return ChoiceAgreement;
        default:
            return null;
    }
};
const Field = (props) => {
    var _a;
    const { field, callback, translateStore: { translate } } = props;
    const { type } = field;
    if (type === 'hidden') {
        return React.createElement(Hidden, { field: field, callback: callback });
    }
    const Component = fieldFromType(type);
    if (!Component) {
        ErrorUtil.pushErrorToTeliaRumAndLog(new Error(`Unknown field of type '${type}'`));
        return null;
    }
    if (!field.isRequired && !((_a = field.label) === null || _a === void 0 ? void 0 : _a.includes(translate('field.optional')))) {
        field.label = `${field.label} (${translate('field.optional')})`;
    }
    if (field.isReadOnly) {
        field.className = `${field.className} is-static`;
    }
    return (React.createElement(FieldContainer, { field: field },
        React.createElement(FieldHelper, { field: field }, ({ helpMessage, errorMessage }) => React.createElement(Component, { field: field, helpMessage: helpMessage, errorMessage: errorMessage, callback: callback }))));
};
export default inject('translateStore')(observer(Field));
//# sourceMappingURL=Field.js.map